<template>
  <div id="model" :class="{'plan-open': planOpen, 'hidden': hide}">
    <iframe
      id="model-frame"
      title="Livmore 3D Building"
      aria-label="Livmore Rotatable 3D Model"
      name="model"
      src="static/model/index.html"
      frameborder="0"
      v-if="enabled && !ieDetected"
      :class="{ 'focused': frameFocused }"
    ></iframe>
    <div class="ieDetected" :class="{'show': ieDetected}">
      Please use a Modern Browser(Chrome or Firefox) to view the 3D Model.
    </div>
    <div
      class="model_instructions"
      :class="{ active: enabled && showInstructions}"
      @click="showInstructions = false;"
    >
      Left Click and Drag to Rotate / Mouse wheel to Zoom
      <br>
      WASD to Rotate / Q,E to Zoom In / Out
    </div>
    <div class="kp_container" :class="{show: kpActive}">
      <div
        class="kp"
        :style="{'background-image': 'url(' + kpImg + ')'}"
        v-if="kpImg !== null"
        :aria-label="'2d keyplate' + planName"
      >
      </div>
    </div>
    <div class="kp_toggle" v-if="planOpen && enabled" @click="toggleKP()">
      <button
        class="kp_btns"
        v-if="kpActive"
        :aria-label="'view 3d building model'"
      >
        view building
      </button>
      <button
        class="kp_btns"
        v-if="!kpActive"
        :aria-label="'view 2d keyplate' + planName"
      >
        view keyplate
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from './../EventBus';

export default {
  name: 'app-model',
  props: ['soldUnits'],
  data() {
    return {
      baseUrl: 'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
      planOpen: false,
      hide: true,
      kpActive: false,
      kpImg: null,
      enabled: true,
      plan: null,
      ieDetected: false,
      showInstructions: false,
      frameFocused: false,
      frameCheck: null
    };
  },
  methods: {
    closePlan() {
      this.kpActive = false;
      this.planOpen = false;
    },
    openPlan() {
      this.planOpen = true;
      this.showInstr();
    },
    toggleModel(status) {
      this.hide = status;
    },
    setActivePage(page) {
      if (page === 'app-model') {
        this.resetModel();
      } else if (page === 'app-landing') {
        this.setModel();
      }
    },
    toggleKP() {
      this.kpActive = !this.kpActive;
    },
    msieversion() {
      const ua = window.navigator.userAgent;
      this.ieDetected = false;

      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        // return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        this.ieDetected = true;
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        // var rv = ua.indexOf('rv:');
        // return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        this.ieDetected = true;
      }

      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        // return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        this.ieDetected = true;
      }
      // other browser
    },
    setKP(plan) {
      this.plan = plan;
      // console.log('find kp', plan);
      this.kpImg = this.baseUrl + plan.conditions[0].images.find(img => img.type === 'kp').url;

      this.toggleModel(false);

      if (this.enabled) {
        // EventBus.$emit('setYaw', plan.dir);
        let distance = 500;
        if (!this.ieDetected) {
          const orientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
          const deviceOrientation = orientation.angle;

          // ipad landscape, then ipad portrait
          if ((deviceOrientation === 90 || deviceOrientation === 270) && window.innerWidth === 1024 && window.innerHeight === 768) {
            distance = 380;
          } else if ((deviceOrientation === 0 || deviceOrientation === 180) && window.innerWidth === 768 && window.innerHeight === 1024) {
            distance = 250;
          } else if ((deviceOrientation === 90 || deviceOrientation === 270) && window.innerWidth === 1366 && window.innerHeight === 1024) {
            // ipad pro landscape
            distance = 380;
          } else if ((deviceOrientation === 0 || deviceOrientation === 180) && window.innerWidth === 1024 && window.innerHeight === 1366) {
            // ipad pro portrait
            distance = 250;
          }
        }

        if (plan.conditions[0].condition_name !== '') {
          this.setYaw(plan.conditions[0].condition_name, distance);
        } else {
          this.setYaw(plan.dir, distance);
        }

        this.applyUnits();
      } else {
        this.kpActive = true;
      }
    },
    applyUnits() {
      if (this.plan) {
        const units = [];
        const unitList = this.plan.conditions[0].suites;
        const holdUnits = [];
        for (let i = 0; i < unitList.length; i += 1) {
          const newUnit = this.convertToUnitySuite(unitList[i]);
          const isSoldUnit = this.soldUnits.filter(soldUnit => soldUnit.unit === newUnit.toString() && soldUnit.status === 'sold');
          const isHoldUnit = this.soldUnits.filter(soldUnit => soldUnit.unit === newUnit.toString() && soldUnit.status === 'hold');

          if (isSoldUnit.length === 0 && isHoldUnit.length === 0) {
            units.push(newUnit);
          } else if (isHoldUnit.length > 0) {
            holdUnits.push(newUnit);
          }
        }
        this.resetUnits();
        this.setSelected(units);
        this.setHold(holdUnits);
      }
    },
    setSelected(selectedUnits) {
      // this.resetUnits();
      window.frames.model.pc.app.fire('selectUnits', selectedUnits);
    },
    setHold(holdUnits) {
      // this.resetUnits();
      window.frames.model.pc.app.fire('holdUnits', holdUnits);
    },
    resetUnits() {
      window.frames.model.pc.app.fire('clearUnits');
    },
    setYaw(letterDir, distance) {
      window.frames.model.pc.app.fire('setDirection', letterDir, distance);
    },
    setSaturation(saturated) {
      window.frames.model.pc.app.fire('saturate', saturated);
    },
    convertToUnitySuite(pmObj) {
      let floor = pmObj.floor;
      let suite = pmObj.suite;
      if (floor.length === 1) {
        floor = '0' + floor;
      }
      if (suite.length === 1) {
        suite = '0' + suite;
      }
      return floor + suite;
    },
    checkDeviceWidth() {
      const intViewportHeight = window.innerHeight;
      const intViewportWidth = window.innerWidth;
      // this.viewportW = intViewportWidth;
      if (intViewportWidth < 767) {
        this.enabled = false;
      } else {
        this.enabled = true;
      }
    },
    pcReady() {
      if (this.plan !== null) {
        setTimeout(() => {
          this.setKP(this.plan);
        }, 350, this);
      }
    },
    showInstr() {
      this.showInstructions = true;
      setTimeout(() => {
        this.showInstructions = false;
      }, 3000);
    },
    iframeHasFocus() {
      this.frameFocused = (document.activeElement === document.getElementById('model-frame'));
    },
    iframeReceivedFocus() {
      console.log('frame got focus');
      this.frameFocused = true;
    }
  },
  computed: {
    planName() {
      if (this.plan && this.plan.name) {
        return ' for ' + this.plan.name;
      }
      return '';
    }
  },
  watch: {
    kpActive() {
      if (!this.kpActive) {
        this.showInstr();
      }
    }
  },
  created() {
    this.msieversion();
  },
  beforeDestroy() {
    if (this.frameCheck) {
      clearInterval(this.frameCheck);
    }
  },
  mounted() {
    EventBus.$on('pcReady', this.pcReady);
    EventBus.$on('updatedSoldUnits', this.applyUnits);

    EventBus.$on('setActivePage', this.setActivePage);
    EventBus.$on('openPlan', this.openPlan);
    EventBus.$on('closePlan', this.closePlan);
    EventBus.$on('toggleModel', this.toggleModel);
    EventBus.$on('setKP', this.setKP);

    // EventBus.$on('setYaw', this.setYaw);
    EventBus.$on('setSelected', this.setSelected);


    EventBus.$on('setSelected', this.setSelected);
    EventBus.$on('resetUnits', this.resetUnits);
    EventBus.$on('setSaturation', this.setSaturation);

    window.addEventListener('onorientationchange', this.checkDeviceWidth);
    window.addEventListener('resize', this.checkDeviceWidth);

    this.checkDeviceWidth();
    this.frameCheck = setInterval(this.iframeHasFocus, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./../globals.scss";

#model {
  position: fixed;
  top: 0px;
  right: 0;
  width: 50vw;
  height: 100vh;

  transition: opacity 0.5s ease-out;
  opacity: 1;
  z-index: 1;

  &.active {
    opacity: 1;
    // transform: translateX(0vw);
    z-index: 10;
  }

  .ieDetected {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: $livmoreBeige;

    color: $livmoreBlack;
    font-size: 24px;
    display: none;
    text-align: center;
    align-items: center;
    justify-content: center;

    &.show {
      display: flex;

    }
  }

  iframe {
    width: calc(100% - 0.4rem);
    height: calc(100% - 0.4rem);
    margin-top: 0.2rem;
  }

  iframe:focus, iframe:active, iframe:focus-within, iframe.focused {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
  }

  #application-canvas:focus {
    background: black;
  }

  .model_instructions {
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    background: $livmoreBlack;
    color: $livmoreBeige;
    padding: 15px;
    line-height: 1.5;
    transition: opacity 1s ease-out;
    opacity: 0;

    &.active {
      opacity: 1;
      pointer-events: all;
    }
  }

  .kp_container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // height: calc(100vh - 150px);
    height: 100%;
    opacity: 0;
    pointer-events: none;
    background: $livmoreBeige;

    transition: all 0.35s ease-out;

    .kp {
      background: $livmoreBeige;
      height: 100%;
      max-width: 500px;
      margin: 0 auto;

      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &.show {
      opacity: 1;

    }
  }

  .kp_toggle {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    padding: 20px;
    .kp_btns {
      font-family: $mainFont;
      color: $livmoreBeige;
      background: $livmoreBlack;
      // color: $livmoreBeige;
      // background: $livmoreRed;
      border: none;
      font-size: 0.85rem;
      letter-spacing: 0.75px;
      padding: 5px 30px;
      // height: 20px;
      line-height: 20px;

      // line-height: 2.5;
      display: inline-block;
      cursor: pointer;
      transition: all 0.5 ease-out;

      &:active {
        transform: scale(0.95);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &.plan-open {
    top: 0;
    right: 0;
    width: 50vw;
    height: calc(100vh - #{$desktopFooterHeight});
  }

  &.hidden {
    // display: none;
    opacity: 0;
    pointer-events: none;
  }
}

@media screen and (min-width: 1281px) and (orientation: landscape) {
  #model {

    &.active {

    }

    iframe {

    }

    .kp_container {

      .kp {
      }
    }

    .kp_toggle {

      .kp_btns {

      }
    }

    &.plan-open {
      height: calc(100vh - #{$desktopFooterHeight});
    }
  }
}

@media screen and (max-width: 1280px) {
  #model {

    &.active {

    }

    iframe {

    }

    .kp_container {

      .kp {

      }

      &.show {
      }
    }

    .kp_toggle {

      .kp_btns {

      }
    }

    &.plan-open {
      height: calc(100vh - #{$desktopFooterHeight1280});
    }
  }
}

@media screen and (max-width: 1024px) {
  #model {

    &.active {

    }

    iframe {

    }

    .kp_container {

      .kp {

      }

      &.show {
      }
    }

    .kp_toggle {

      .kp_btns {

      }
    }
  }
}

@media screen and (max-width: 768px) {
  #model {
    // width: 100vw;

    &.active {

    }

    iframe {

    }

    .kp_container {
      height: 100vh;
      // padding: 40px;
      .kp {
        width: 85%;
        margin: 0 auto;
        background-size: contain;
      }

      &.show {
      }
    }

    .kp_toggle {

      .kp_btns {

      }
    }

    &.plan-open {
      // width: 100vw;
      // height: calc(100vh - 75px);
    }
  }
}

@media screen and (max-width: 767px) {
  #model {
    width: 100vw;
    display: none;

    &.active {

    }

    iframe {
      display: none;
    }

    .kp_container {
      height: calc(100%);
      // padding: 40px;
      .kp {
        width: 85%;
        margin: 0 auto;

      }

      &.show {
      }
    }

    .kp_toggle {
      padding-left: 0px;
      padding-right: 0px;

      bottom: 55px;
      .kp_btns {

      }
    }

    &.plan-open.active {
      width: 100vw;
      height: calc(100vh - 75px);
      display: block;
    }
  }
}

@media screen and (max-width: 415px) {
  #model {
    iframe {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Model.vue